module.exports = __webpack_public_path__ + "spg_logo_350.b8b0b60486c91f7c8f88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spg_logo_350.png
// module id = 409
// module chunks = 1